import React from "react";
import { withNamespaces } from 'react-i18next';

const AcCusto = ({t}) => {
  return (
    <>
      <div className="accordion" id="accordionExample_custo">
        {/* 1 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="custo_heading1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#custo_collapse1"
              aria-expanded="true"
              aria-controls="custo_collapse1"
            >
              {t('moduleFaqs:S4.A.A1.T') }
            </button>
          </h2>
          <div
            id="custo_collapse1"
            className="accordion-collapse collapse"
            aria-labelledby="heading1"
            data-bs-parent="#accordionExample_custo"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S4.A.A1.P1') }}></p>
              <p className="p_accordion">
                <span dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S4.A.A1.P2') }}></span>
                <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S4.A.A1.Link.Link')} title={t('moduleFaqs:S4.A.A1.Link.Title')}>{t('moduleFaqs:S4.A.A1.Link.NameLink')}</a>
                <span  dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S4.A.A1.P3') }}></span>
              </p>
            </div>
          </div>
        </div>
        {/* 2 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="custo_heading2">
            <button
              className="accordion-button collapsed text-left"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#custo_collapse2"
              aria-expanded="false"
              aria-controls="custo_collapse2"
            >
              {t('moduleFaqs:S4.A.A2.T') }
            </button>
          </h2>
          <div
            id="custo_collapse2"
            className="accordion-collapse collapse"
            aria-labelledby="heading2"
            data-bs-parent="#accordionExample_custo"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S4.A.A2.P1') }}>
              </p>
            </div>
          </div>
        </div>
        {/* 3*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="custo_heading3">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#custo_collapse3"
              aria-expanded="false"
              aria-controls="custo_collapse3"
            >
              {t('moduleFaqs:S4.A.A3.T') }
            </button>
          </h2>
          <div
            id="custo_collapse3"
            className="accordion-collapse collapse"
            aria-labelledby="heading3"
            data-bs-parent="#accordionExample_custo"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S4.A.A3.P1') }}></p>
            </div>
          </div>
        </div>
        {/* 4*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="custo_heading4">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#custo_collapse4"
              aria-expanded="false"
              aria-controls="custo_collapse4"
            >
              {t('moduleFaqs:S4.A.A4.T') }
            </button>
          </h2>
          <div
            id="custo_collapse4"
            className="accordion-collapse collapse"
            aria-labelledby="custo_heading4"
            data-bs-parent="#accordionExample_custo"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S4.A.A4.P1') }}></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (AcCusto);
